import React, { useEffect, useState } from 'react';
import { Col, Row, Select, Spin, Modal, Icon } from 'antd';
import { connect } from 'react-redux';
import { getAllLookupsRanks, updateRank, getAllRanks, GetRanksByUserName, deleteRank } from '../../actions/index';
import { CloseCircleOutlined } from '@ant-design/icons';

import GetRanksDate from '../Inc/GetRanksDate';

const { Option } = Select;
const LoadingIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;

const EagleRanks = ({
  GetAllLookupsRanks,
  GetAllRanks,
  getAllLookupsRanks,
  updateRank,
  getAllRanks,
  deleteRank,
  alumniProfileinfo,
  eagleInfo,
  GetRanksByUserName,
  alumniRanks,
  alumniRanksLoading
}) => {
  const [selectedRankIds, setSelectedRankIds] = useState([]);
  const [selectedRanks, setSelectedRanks] = useState([]);
  const [loading, setLoading] = useState(false);

  const currentPath = window.location.pathname;
  const isViewOnly = currentPath === "/my-profile" || currentPath === "/alumni-dashboard";
  const isMaintainAlumni = currentPath.indexOf("/maintain-alumni") === 0 || currentPath.indexOf("/list-and-search") === 0;

  const canEdit = isMaintainAlumni ? false : !isViewOnly;

  let userId = "";
  if (isViewOnly) {
    const loggedinUser = JSON.parse(localStorage.getItem("user") || "{}");
    userId = loggedinUser && loggedinUser.account ? loggedinUser.account.userId : "";
  } else if (isMaintainAlumni) {
    if (alumniProfileinfo && alumniProfileinfo.profile && alumniProfileinfo.profile.userId) {
      userId = alumniProfileinfo.profile.userId;
    }
  }

  useEffect(() => {
    setLoading(true);
    const API_list = [];

    if (isMaintainAlumni && userId) {
      API_list.push(getAllLookupsRanks(), getAllRanks(userId))
    } else if(!isMaintainAlumni) {
      API_list.push(getAllLookupsRanks(), GetRanksByUserName())
    }

    Promise.all(API_list)
        .finally(() => setLoading(false));
  }, [getAllLookupsRanks, getAllRanks, userId]);

  // The API integration is complete. The next steps are to display the data on the UI and implement the delete functionality.
  useEffect(() => {
    if (!isMaintainAlumni && (alumniRanks && alumniRanks.length)) { 
      const filteredRanks = alumniRanks
        .flatMap(record => (
           record.alumniRanks
            .map(rank => ({
              ...rank,
              imageUrl100: rank.imageFilePath,
              name: rank.rankName,
              memberId: record.memberId
            }))
            .filter(rank => rank.isComplete)
        ));

      setSelectedRanks(filteredRanks);
      setSelectedRankIds(filteredRanks.map(r => r.id));
    } 
    else if(isMaintainAlumni && (GetAllRanks && GetAllRanks.length)){
      const filteredRanks = GetAllRanks.filter(rank => rank.leaderApprovedUserId);
      setSelectedRanks(filteredRanks);
      setSelectedRankIds(filteredRanks.map(r => r.id));
    }
    else {
      setSelectedRanks([]);
      setSelectedRankIds([]);
    }
  }, [alumniRanks, GetAllRanks]);

  const getPersonGuid = function () {
    if (alumniProfileinfo && alumniProfileinfo.profile && alumniProfileinfo.profile.personGuid) {
      return alumniProfileinfo.profile.personGuid;
    }
    return null;
  };

  const handleSelectRank = async function (rankId) {
    const selectedRank = GetAllLookupsRanks.find(r => r.id === rankId);
    const rankName = selectedRank ? selectedRank.name : "";

    if (!canEdit || selectedRankIds.indexOf(rankId) !== -1) return;
    const personGuidFromAlumni = getPersonGuid();
    if (!userId || !personGuidFromAlumni) return;

    try {
      setLoading(true);
      await updateRank(personGuidFromAlumni, rankId, rankName, eagleInfo && eagleInfo.eagleBoardReviewDate);
      await getAllRanks(userId);
    } catch (err) {
      Modal.error({ title: 'Error', content: err.message || 'Something went wrong' });
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteRank = async function (rankId, rankName, status) {
    if (!canEdit) return;
    const personGuidFromAlumni = getPersonGuid();
    if (!userId || !personGuidFromAlumni) return;

    if (status && (status.toLowerCase().includes('awarded') || status.toLowerCase().includes('approved'))) {
      return Modal.confirm({
        title: 'Rank Deletion Restricted',
        content: (
          <span>
            Approved/Awarded Rank Cannot Be Deleted
          </span>
        ),
        okText: 'Ok',
        // cancelText: 'No',
        onOk: async function () {
         setLoading(false);
        }
      });
    }
    Modal.confirm({
      title: 'Confirm Delete',
      content: (
        <span>
          Are you sure you want to delete <b>{rankName}</b> rank?
        </span>
      ),
      okText: 'Yes',
      cancelText: 'No',
      onOk: async function () {
        try {
          setLoading(true);
          await deleteRank(personGuidFromAlumni, rankId, rankName);
          await getAllRanks(userId);
        } catch (err) {
          Modal.error({ title: 'Error', content: err.message || 'Something went wrong while deleting rank.' });
        } finally {
          setLoading(false);
        }
      }
    });
  };

  const renderRanksCards = function () {
    if (loading) {
      return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', height: '400px' }}>
          <Spin indicator={LoadingIcon} className="loading-state text-center width-100" tip="Loading Eagle Ranks..." />
        </div>
      );
    }
    else if (!selectedRanks || selectedRanks.length === 0) {
      var emptyMessage = isViewOnly
        ? "You haven’t earned any ranks yet."
        : "No ranks have been selected yet.";

      return (
        <Row className='width-100' type='flex' align='middle' justify='center' style={{ height: '100%' }}>
          <Col className='center margin-top-10' xs={24}>
            <Row type='flex' align='bottom' justify='center'>
              <span className='memb-exp'>{emptyMessage}</span>
            </Row>
          </Col>
        </Row>
      );
    }

    const formatDate = function (dateString) {
      if (!dateString) return '-';
      var date = new Date(dateString);
      var mm = ("0" + (date.getMonth() + 1)).slice(-2);
      var dd = ("0" + date.getDate()).slice(-2);
      var yyyy = date.getFullYear();
      return mm + "/" + dd + "/" + yyyy;
    };

    return (
      <Row gutter={[10, 10]} style={{ padding: '10px', width: '100%' }}>
        {selectedRanks.map(function (rank) {
          const earnedDate = GetRanksDate(rank, eagleInfo);
          return (
            <Col key={rank.id}>
              <div className='rank-div'>
                {rank.imageUrl100 ? (
                  <img
                    src={rank.imageUrl100}
                    alt={rank.name}
                    style={{
                      width: '30px',
                      height: '30px',
                      marginRight: '10px',
                      borderRadius: '5px',
                    }}
                  />
                ) : <div
                  style={{
                    width: '30px',
                    marginRight: '10px',
                  }}
                    >
                      </div>
                  }

                <div
                  style={{
                    flex: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                  }}
                >
                  <span style={{ fontWeight: 600 }}>{rank.name}</span>

                  <span style={{ fontSize: '12px', color: '#555' }}>
                    Earned: {earnedDate ? earnedDate : '-'}
                  </span>

                  {!isMaintainAlumni && (
                    <span
                      className='sub-title display-block'
                      style={{ padding: '0px', color: '#919191' }}
                    >
                      MID - {rank.memberId}
                    </span>
                  )}
                </div>

                {canEdit && (
                  <CloseCircleOutlined
                    style={{ fontSize: '16px', color: 'red', marginLeft: '8px', cursor: 'pointer' }}
                    onClick={function () { handleDeleteRank(rank.id, rank.name, rank.status); }}
                  />
                )}
              </div>
            </Col>
          );
        })}
      </Row>
    );
  };

  return (
    <div>
      <Col>
        <div className='container min-height-710'>
          <div className='widget-content' style={{ height: '100%' }}>
            <Row type="flex" justify="space-between">
              <div className='widget-header-text'>Eagle's Ranks</div>
            </Row>

            <Row className='widget-content-section height-360' type="flex" style={{ height: '500px', alignContent: 'flex-start' }}>
              {renderRanksCards()}
            </Row>

            {canEdit && (
              <Row className='addLocalawards' style={{ margin: '10px 0px' }}>
                <Col span={24}>
                  <span className='small-txt display-block'> Please add your Ranks: </span>
                </Col>
                <Col span={24}>
                  <Select
                    className='awardsselect'
                    showSearch
                    optionLabelProp="label"
                    style={{ width: "100%" }}
                    filterOption={function (input, option) {
                      return typeof option.children === 'string' &&
                        option.children.toLowerCase().indexOf(input.toLowerCase()) !== -1;
                    }}
                    onChange={handleSelectRank}
                  >
                    {GetAllLookupsRanks && GetAllLookupsRanks.map(function (rank) {
                      return (
                        <Option
                          key={rank.id}
                          value={rank.id}
                          label={rank.name}
                          disabled={selectedRankIds.indexOf(rank.id) !== -1}
                        >
                          {rank.name}
                        </Option>
                      );
                    })}
                  </Select>
                </Col>
              </Row>
            )}
          </div>
        </div>
      </Col>
    </div>
  );
};

const mapStateToProps = (state) => ({
  GetAllLookupsRanks: state.GetLookupsRanksReducer.GetAllLookupsRanks,
  GetAllRanks: state.GetRanksReducer.GetAllRanks,
  alumniProfileinfo: state.alumniinforeducer.profileinfo,

  alumniRanksLoading: state.getAlumniEagleRanksByUsernameReducer.loading,
  alumniRanks: state.getAlumniEagleRanksByUsernameReducer.alumniRanks,


  // eagleInfo: state.alumnieagleinforeducer.eagleinfo,
});

const mapDispatchToProps = { getAllLookupsRanks, updateRank, getAllRanks, deleteRank, GetRanksByUserName };

export default connect(mapStateToProps, mapDispatchToProps)(EagleRanks);



// WEBPACK FOOTER //
// ./src/components/MaintainAlumni/EagleRanks.js